import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';

import { useGetHsptlzFormEntryData } from '../model';

export const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { redirectData, patientInfoData } = useGetHsptlzFormEntryData(searchParams);
  const setPatientInfoData = useBoundStore((state) => state.hsptlzForm.setPatientInfoData);
  const setRedirectData = useBoundStore((state) => state.hsptlzForm.setRedirectData);

  useEffect(() => {
    setPatientInfoData(patientInfoData);
    setRedirectData(redirectData);

    if (redirectData.result == '0') {
      navigate(redirectData.redirectUrl, { replace: true });
    }
  }, [redirectData]);

  return null;
};
